module.exports = __webpack_public_path__ + "img/agents_faults_en.8e01bd3e.svg";